<div class="e-control-bar">
  <div class="e-navigation-strip">
    <button 
      class="e-control-button"
      (click)="onExportButtonClick()"
      [disabled]="rowCount === 0"
      aria-label="Export claims">
      <span class="fas fa-file-export"></span>
      Export
    </button>

    <button 
      class="e-control-button"
      (click)="onAddClaim()"
      aria-label="Add new claim">
      <span class="fa fa-plus"></span>
      Add Claim
    </button>

    <button 
      class="e-control-button"
      [disabled]="!canEditClaim"
      (click)="onEditClaim()"
      aria-label="Edit claim">
      <span class="fa fa-pencil"></span>
      Edit Claim
    </button>

    <button 
      class="e-control-button"
      [disabled]="isDeleteDisabled()"
      (click)="onDeleteClaim()"
      aria-label="Delete claim">
      <span class="fa fa-trash"></span>
      Delete Claim
    </button>
  </div>
</div>

<div>
  <claims-generic-loader [genericLoaderDetail]="genericLoaderData"></claims-generic-loader>
</div>

@if (isGenericModalDialogVisible) {
  <claims-generic-modal-dialog [showOptionalFileNameInput]="true"
    [modalTitleIconCss]="genericModalDialogConstant.modalDialogExportTitleIconCss"
    [modalTitle]="genericModalDialogConstant.modalDialogExportTitle"
    [modalTitleDescription]="genericModalDialogConstant.modalDialogExportTitleDescription"
    [modalNotificationIconCss]="genericModalDialogConstant.modalDialogExportNotificationIconCss"
    [modalNotificationIconWithText]="genericModalDialogConstant.modalDialogExportNotificationIconWithText"
    [modalNotificationIconMessageList]="genericModalDialogNotificationMessageList"
    [modalCancelButtonText]="genericModalDialogConstant.modalDialogExportCancelButtonText"
    [modalSubmitButtonText]="genericModalDialogConstant.modalDialogExportSubmitButtonText"
    [modalExportFileName]="exportFileName" (eventSubmitNotify)="onGenericModalDialogSubmitClick($event)"
    (eventCancelNotify)="onGenericModalDialogCancelClick($event)">
  </claims-generic-modal-dialog>
}